<template>
    <v-btn
    variant="flat"
    rounded="lg"
    height="36"
    width="125"
    class="footer-btn-metrika">
        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_1177_1781" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="20">
        <path d="M9.3 19.2864C14.4362 19.2864 18.6 15.1291 18.6 10.0007C18.6 4.87235 14.4362 0.714996 9.3 0.714996C4.16375 0.714996 0 4.87235 0 10.0007C0 15.1291 4.16375 19.2864 9.3 19.2864Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_1177_1781)">
        <path d="M0 0.715729H18.6V19.2872H0V0.715729Z" fill="url(#paint0_linear_1177_1781)"/>
        <path d="M0 12.1429H5.72308V19.2857H0V12.1429Z" fill="url(#paint1_linear_1177_1781)"/>
        <path d="M5.72314 9.85716C5.72314 8.65716 5.72314 8.05716 5.95708 7.59859C6.16283 7.1954 6.49114 6.8676 6.89494 6.66216C7.35422 6.42859 7.95514 6.42859 9.15699 6.42859H12.877V19.2857H5.72314V9.85716Z" fill="url(#paint2_linear_1177_1781)"/>
        <path d="M12.877 0.714294H18.6V19.2857H12.877V0.714294Z" fill="url(#paint3_linear_1177_1781)"/>
        </g>
        <defs>
        <linearGradient id="paint0_linear_1177_1781" x1="13.3298" y1="14.1793" x2="-1.9841" y2="-7.20014" gradientUnits="userSpaceOnUse">
        <stop stop-color="#4643B9"/>
        <stop offset="1" stop-color="#1E8AFF"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1177_1781" x1="6.10008" y1="16.8143" x2="-10.8158" y2="13.8633" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF002E"/>
        <stop offset="1" stop-color="#FFADA1"/>
        </linearGradient>
        <linearGradient id="paint2_linear_1177_1781" x1="49.7193" y1="47.5" x2="53.9651" y2="12.722" gradientUnits="userSpaceOnUse">
        <stop stop-color="#3C3BA0"/>
        <stop offset="0.49" stop-color="#1E8AFF"/>
        <stop offset="1" stop-color="#00B2FF"/>
        </linearGradient>
        <linearGradient id="paint3_linear_1177_1781" x1="12.877" y1="1.66929" x2="29.0642" y2="10.0467" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFEA1A"/>
        <stop offset="1" stop-color="#FFB800"/>
        </linearGradient>
        </defs>
        </svg>
        <div class="ml-2">Метрика</div>
    </v-btn>
</template>
<script>
export default {
    name: 'BtnMeteika'
}
</script>